import styles from './index.module.scss';
import { utility } from '@phi/components';
import { VNode, h } from 'vue';
import { Label } from '@components/form';
import { Flex } from '@phi/components/layout';

export function SettingsEntry(
    title: string,
    explanation: string,
    icon: VNode,
    input: VNode,
) {
    return h(Label, { align: 'flex-start', space: 'between', class: styles.label }, {
        label: () => h('div', [
            h(Flex, { as: 'header', class: [utility.normal_weight], direction: 'row', gap: 'tight', align: 'center' }, () => [
                h('div', { class: [styles.icon, utility.round] }, icon),
                h('span', title),
            ]),
            h('div', {
                class: [
                    styles.explanation,
                    utility.normal_weight,
                    utility.small,
                    utility.slightly_faded,
                ]
            }, explanation),
        ]),
        input: () => input,
    });
}

export function SettingsEntrySingleLine(
    title: string,
    explanation: string | undefined,
    icon: VNode,
    input: VNode,
) {
    return h('div', { class: utility.margin_gap_1 }, [
        h('header', {
            class: [utility.normal_weight, utility.flex, utility.gap_2],
        }, [
            h('div', { class: [styles.icon, utility.round] }, icon),
            h('span', title),
        ]),
        explanation && h('div', {
            class: [
                styles.explanation,
                utility.normal_weight,
                utility.small,
                utility.slightly_faded,
            ],
        }, explanation),
        input,
    ]);
}
